// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081808/js/" + chunkId + "." + {"44":"b132133f","225":"20a1d6c3","481":"78329705","486":"2e7f7fc0","770":"f69eb9f6"}[chunkId] + ".0.005041024124875393.chunk.js";
};